import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function ChannelSelector({ label, channel, setChannel }) {
    return (
        <FormControl variant="outlined" style={{ marginTop: '10px', width: '100%' }}>
            <InputLabel id="channel-label">{label || "Channel"}</InputLabel>
            <Select
                labelId="channel-label"
                value={channel}
                onChange={(e) => setChannel(e.target.value)}
                label={label || "Channel"}
            >
                {[...Array(16)].map((_, index) => (
                    <MenuItem key={index} value={index + 1}>
                        {index + 1}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}